import { Utils } from './Utils';
import { StringUtils } from './StringUtils';

export class AuditLogDetailHelper {

    public static renderDetailRow(data: any): string {
        //var exceptionData = _.escape(data.ExceptionData).replace(brRegExp, '<br/>');
        var css = data.Type.toLowerCase();
        if (css === 'error') {
            css = 'danger';
        } else if (css === 'information') {
            css = 'info';
        }

        var result = `<div class='note note-${css}'>
                    <h5>Description</h5>
                    <p>${data.Message}</p>
                    <p>&nbsp;</p>`;
        switch (data.Action) {
            case "CustomerConfigure":
            case "CustomerOperationConfigure":
            case "CustomerChannelConfigure":
            case "ChannelEditConfiguration":
            case "PlatformEditConfiguration":
            case "SystemConfigurationEdit":
            case "JurisdictionEditConfiguration":
                result += AuditLogDetailHelper.renderConfigurationDataDetailRow(data);
                break;
            case "ExportConfigurationOverview":
                result += AuditLogDetailHelper.renderExportOverviewDetailRow(data);
                break;
            default:
                result += AuditLogDetailHelper.renderDefaultDetailRow(data);
                break;
        }
        result += '</div>';
        return result;
    }

    private static renderDefaultDetailRow(data: any): string {
        let result = `<h5>Old value</h5>`;
        result += `<p>${Utils.valueOrDefault(data.OldData, '-')}</p>
                    <p>&nbsp;</p>`;
        result += `<h5>New value</h5>`;
        result += `<p>${Utils.valueOrDefault(data.NewData, '-')}</p>
                    <p>&nbsp;</p>`;
        return result;
    }

    private static renderConfigurationDataDetailRow(data: any): string {
        var jsonOld: Object = null;
        var jsonNew: Object = null;
        try {
            jsonOld = JSON.parse(data.OldData);
        } catch (e) {
            jsonOld = null;
        }

        try {
            jsonNew = JSON.parse(data.NewData);
        } catch (e) {
            jsonNew = null;
        }
        let result = '<table style="width: 40%;" class="errorLogContextData table-bordered table-hover table table-striped">';
        result += '<tr><th>Name</th><th>Old value</th><th>New value</th></tr>';
        for (let property in jsonOld) {
            let oldValue = StringUtils.escapeHtml(jsonOld[property]).replace("(L)", "<label class='fa fa-lock'></label>");
            let newValue = StringUtils.escapeHtml(jsonNew[property]).replace("(L)", "<label class='fa fa-lock'></label>");
            result += `<tr><td>${property}</td><td>${oldValue}</td><td>${newValue}</td></tr>`;
        }
        for (let property in jsonNew) {
            if (!jsonOld.hasOwnProperty(property)) {
                let oldValue = StringUtils.escapeHtml(jsonOld[property]).replace("(L)", "<label class='fa fa-lock'></label>");
                let newValue = StringUtils.escapeHtml(jsonNew[property]).replace("(L)", "<label class='fa fa-lock'></label>");
                result += `<tr><td>${property}</td><td>${oldValue}</td><td>${newValue}</td></tr>`;
            }
        }

        result += '</table>';
        return result;
    }

    private static renderExportOverviewDetailRow(data: any): string {
        let result = '<table style="width: 40%;" class="errorLogContextData table-bordered table-hover table table-striped">';
        const keys = data.NewData.split(",");
        for (let i = 0; i < keys.length; ++i) {
            result += `<tr><td>${keys[i]}</td></tr>`;
        }
        result += '</table>';
        return result;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Utils/AuditLogDetailHelper.ts
 **/